import React from 'react'

class Footer extends React.Component {
    render() {
        return (
            <section id="footer">
                <ul className="copyright">
                    <li>Copyright &copy; Cely Rose Photography 2022. Tous droits réservés.</li>
                </ul>
            </section>
        )
    }
}

export default Footer
